import React, { useState } from 'react';
import { XIcon, EnvelopeSimpleIcon } from '@phosphor-icons/react';
import Button from 'components/Button';
import { useFeedback } from 'contexts/feedback';
import { subscribeNewsletter } from 'api/newsletter';
import { useMutation } from '@tanstack/react-query';

export default function NewsletterPopup({ visible, setVisible, toolName }) {

    const { setSuccess, setError } = useFeedback();
    const [isSubmitted, setIsSubmitted] = useState(false);

    const { mutate, status } = useMutation({
        mutationKey: ['subscribeNewsletter'],
        mutationFn: subscribeNewsletter,
        onSuccess: () => {
            setSuccess('Iscrizione alla newsletter avvenuta con successo');
            setIsSubmitted(true);
        },
        onError: (error) => {
            console.error("Error subscribing to newsletter:", error);
            setError('Errore durante l\'iscrizione alla newsletter');
        }
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const email = formData.get('email');

        if (!email || email.trim() === '') {
            setError('L\'email non può essere vuota');
            return;
        }

        mutate({
            data: { email: email.trim(), tool: toolName }
        });
    };

    const handleClose = () => {
        setVisible(false);
    };

    return (
        <div className={`fixed top-0 left-0 w-full h-full bg-black/50 z-[var(--z-modal)] transition-all duration-300 ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
            <div className='bg-white rounded-lg border border-greylight w-full max-w-md mx-4 md:mx-auto mt-40'>
                <div className='flex justify-between items-center p-6 border-b border-greylight'>
                    <p className='text-lg font-medium text-black/90'>Funzione in sviluppo</p>
                    <div onClick={handleClose} className='cursor-pointer text-muted hover:text-grey transition-colors'>
                        <XIcon size={20} />
                    </div>
                </div>

                <div className='p-6'>
                    {!isSubmitted ? (
                        <>
                            <div className='mb-6 text-center'>
                                <div className='inline-flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full mb-4'>
                                    <EnvelopeSimpleIcon size={32} className='text-blue-600' />
                                </div>
                                <h3 className='text-xl font-semibold text-black/90 mb-2'>
                                    {toolName}
                                </h3>
                                <p className='text-black/60'>
                                    Questa funzione è in via di sviluppo. Iscriviti alla newsletter per essere avvisato quando sarà disponibile!
                                </p>
                            </div>

                            <form onSubmit={handleSubmit} className='space-y-4'>
                                <div>
                                    <label htmlFor='newsletter-email' className='block text-sm font-medium text-black/70 mb-2'>
                                        Email
                                    </label>
                                    <input
                                        id='newsletter-email'
                                        type='email'
                                        name='email'
                                        placeholder='tuaemail@esempio.it'
                                        required
                                        className='w-full px-4 py-3 border border-greylight rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                                    />
                                </div>

                                <Button
                                    status={status}
                                    submit
                                    className='w-full'
                                >
                                    {status === 'loading' ? 'Invio in corso...' : 'Iscriviti alla newsletter'}
                                </Button>
                            </form>
                        </>
                    ) : (
                        <div className='text-center py-8'>
                            <div className='inline-flex items-center justify-center w-16 h-16 bg-green-50 rounded-full mb-4'>
                                <svg className='w-8 h-8 text-green-600' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
                                </svg>
                            </div>
                            <h3 className='text-xl font-semibold text-black/90 mb-2'>
                                Iscrizione completata!
                            </h3>
                            <p className='text-black/60'>
                                Ti avviseremo quando la funzione sarà disponibile.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
